import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import MailSideBar from "./Components/MailSideBar";
import NewMail from "./Components/NewMail";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteMailRequest,
  getMailRequest,
  openMail,
} from "../../Redux/actions/home";
import CurrentMail from "./Components/CurrentMail";
import ModalComponent from "../../Components/Modal";
import { RegMed } from "../../Components/CustomStyles";

const IMailPage = ({}) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState({
    delModal: false,
    is_permanent: false,
  });
  const { mailList, isLoading } = useSelector((state) => state.home);
  const [mails, setMails] = useState([]);
  const [replyTo, setReplyTo] = useState(null);
  const [currentMail, setCurrentMail] = useState(mailList[0]);
  const [createNewMail, setCurrentNewMail] = useState({
    isOpen: false,
  });
  const [mailShowingList] = useState([
    {
      id: 1,
      title: "All",
      isSelected: true,
    },
    {
      id: 2,
      title: "Read",
      isSelected: false,
    },
    {
      id: 3,
      title: "Unread",
      isSelected: false,
    },
    {
      id: 4,
      title: "Sent",
      isSelected: false,
    },
  ]);
  let currentTab = mailShowingList.find((f) => f.isSelected).id;

  const handleDropDown = ({ label }) => {
    if (label === "Reply") {
      handleReply(currentMail);
    } else {
      if (label === "Delete for everyone") {
        setShowModal((prev) => ({ ...prev, is_permanent: true }));
      }
      setShowModal((prev) => ({ ...prev, delModal: true }));
    }
  };

  const openNewMail = () => {
    setCurrentNewMail((prev) => ({
      ...prev,
      isOpen: true,
    }));
  };
  const closeNewMail = () => {
    setCurrentNewMail((prev) => ({
      ...prev,
      isOpen: false,
    }));
    setCurrentMail(null);
  };

  const handleCurrentMail = (mail) => {
    if (createNewMail.isOpen) closeNewMail();
    dispatch(openMail(mail));
    setCurrentMail(mail);
  };

  const getMail = (type, bool) => {
    dispatch(getMailRequest(type ?? "", bool ?? false));
  };

  const handleReply = (mail) => {
    setReplyTo(mail);
    openNewMail();
  };

  const deleteMail = () => {
    setShowModal(false);
    dispatch(
      deleteMailRequest(currentMail?.id, showModal?.is_permanent, currentTab)
    );
    setTimeout(() => setCurrentMail(null), 1000);
  };

  useEffect(() => {
    getMail("");
  }, []);

  useEffect(() => {
    // if (mailList.length) setMails(mailList);
    setMails(mailList);
  }, [mailList]);

  return (
    <Container>
      <MailSideBar
        mails={mails}
        handleCurrentMail={handleCurrentMail}
        openNewMail={openNewMail}
        isLoading={isLoading}
        getMail={getMail}
        mailShowingList={mailShowingList}
        setCurrentMail={setCurrentMail}
        currentTab={currentTab}
      />
      {createNewMail.isOpen ? (
        <NewMail
          closeNewMail={closeNewMail}
          replyTo={replyTo}
          setReplyTo={setReplyTo}
        />
      ) : currentMail ? (
        <CurrentMail
          mail={currentMail}
          showModal={showModal.delModal}
          handleDropDown={handleDropDown}
          mailShowingList={mailShowingList}
        />
      ) : null}

      {showModal?.delModal && (
        <ModalComponent
          closeModal={() => setShowModal(false)}
          openModal={showModal?.delModal}
          heading={"Delete Mail"}
          yesBtnTxt={"Yes"}
          noBtnTxt={"Cancel"}
          yesBtn={deleteMail}
          noBtn={() => setShowModal(false)}
        >
          <RegMed>
            Are you sure you want to delete mail
            {showModal?.is_permanent ? " for everone" : ""}?
          </RegMed>
        </ModalComponent>
      )}
    </Container>
  );
};

export default IMailPage;
